<template>
  <!-- ProProxyUI: the box panel's own admin login, kept for admins (Add / Update Server); Open panel opens the Domain -->
  <div class="float-left w-full px-2 pb-2 modal-item">
    <div class="pl-box">
      <div class="pl-head">
        <b>Box panel login</b><span class="pl-dim">admins only</span>
        <a v-if="panelUrl" :href="panelUrl" target="_blank" rel="noopener noreferrer" class="pl-open"><v-icon icon="mdi-open-in-new" size="15"></v-icon> Open panel</a>
      </div>
      <div class="pl-dim pb-2">{{ panelUrl ? `${panelUrl} · opens in a new tab` : 'Enter the Domain first' }}</div>
      <div class="pl-grid">
        <div>
          Username
          <div class="flex">
            <input :value="user" @input="emit('update:user', $event.target.value)" placeholder="admin" autocomplete="off" class="form-control shadow-none rounded-0 text-black">
            <button type="button" class="pl-btn" aria-label="Copy username" @click="copy(user, 'Username')"><v-icon icon="mdi-content-copy" size="16"></v-icon></button>
          </div>
        </div>
        <div>
          Password
          <div class="flex">
            <input :value="password" @input="emit('update:password', $event.target.value)" :type="showPw ? 'text' : 'password'" placeholder="Panel password" autocomplete="new-password" class="form-control shadow-none rounded-0 text-black">
            <button type="button" class="pl-btn" :aria-label="showPw ? 'Hide password' : 'Show password'" @click="showPw = !showPw"><v-icon :icon="showPw ? 'mdi-eye-off' : 'mdi-eye'" size="18"></v-icon></button>
            <button type="button" class="pl-btn" aria-label="Copy password" @click="copy(password, 'Password')"><v-icon icon="mdi-content-copy" size="16"></v-icon></button>
          </div>
        </div>
      </div>
      <div class="pl-dim pt-2">Saved with the server and shown only on this admin page. The dashboard itself keeps using the API token.</div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue';
import { useAlertStore } from '@/stores';

const props = defineProps({ domain: { type: String, default: '' }, user: { type: String, default: '' }, password: { type: String, default: '' } });
const emit = defineEmits(['update:user', 'update:password']);
const showPw = ref(false);
const panelUrl = computed(() => { const d = String(props.domain || '').trim(); return d ? (/^https?:\/\//i.test(d) ? d : `http://${d}`) : ''; });
const copy = async (text, what) => {
  try { await navigator.clipboard.writeText(String(text || '')); useAlertStore().success(`${what} copied`); }
  catch (e) { useAlertStore().error(`Could not copy the ${what.toLowerCase()}`); }
};
</script>

<style scoped>
.pl-box { border: 1px solid var(--ui-line); border-radius: 10px; padding: 10px 12px; }
.pl-head { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; padding-bottom: 2px; }
.pl-dim { color: var(--ui-dim); font-size: 12px; }
.pl-head .pl-dim { flex: 1; }
.pl-open { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border: 1px solid var(--ui-line-strong); border-radius: 6px; font-size: 12px; color: inherit; text-decoration: none; }
.pl-open:hover { background: var(--ui-row-alt); }
.pl-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px 12px; }
.pl-btn { flex: none; padding: 0 9px; border: 1px solid var(--ui-line-strong); border-left: 0; background: transparent; color: inherit; cursor: pointer; }
.pl-btn:hover { background: var(--ui-row-alt); }
</style>
